export class UpdateAvatarRequest {
    base64Data: string = '';
}